<template>
  <div class="box6">
    <pageTitle
      title="核心讲师经验足 授课质量高"
      text="引入大厂经验，实时接轨主流项目业务"
      titleColor="#191c47"
      titColor="#666666"
    />

    <div class="teacher-box" @scroll="handleScroll">
      <div class="box1" ref="content">
        <div
          class="teacher"
          v-for="(item, index) in teacherList.slice(0, 3)"
          :key="index"
          :style="
            `backgroundImage: url(` +
            require(`../../../assets/coursePage/pm/box6/${index + 1}.png`) +
            `)`
          "
          @click="changeCur(index)"
        >
          <!-- <div class="tName">{{ item.name }}</div>
          <div class="tagList">
            <p>
              <span
                v-for="(item1, index1) in item.tag2"
                :key="index1"
                v-html="item1"
              >
                <span v-show="index1 != item.tag.length - 1">| </span>
              </span>
            </p>
          </div> -->
        </div>
        <div class="seat"></div>
      </div>
      <!-- <div class="box2">
        <div
          class="teacher"
          v-for="(item, index) in teacherList.slice(1, 2)"
          :key="`${index}1`"
          :style="
            `backgroundImage: url(` +
            require(`../../../assets/coursePage/pm/box6/${index + 4 + 1}.png`) +
            `)`
          "
          @click="changeCur(index, 1)"
        >
          <div class="tName">{{ item.name }}</div>
          <div class="tagList">
            <p>
              <span
                v-for="(item1, index1) in item.tag2"
                :key="index1"
                v-html="item1"
              >
                <span v-show="index1 != item.tag.length - 1">| </span>
              </span>
            </p>
          </div>
        </div>
        <div class="seat"></div>
      </div> -->
      <!-- <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div> -->
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ teacherList[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in teacherList[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in teacherList[this.cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,

      teacherList: [
        {
          name: "黄老师",
          tag: ["多年产品经理实战经验"],
          tag2: ["多年产品经理实战经验"],
          info: [
            "涉足医疗、早教、地产、社区等诸多领域，负责过百万⽤户量的产品，在C端和B端产品均有多年实战经验。擅⻓产品规划、需求分析、产品设计、数据分析等方向。",
          ],
        },
        // {
        //   name: "毕老师",
        //   tag: ["13年互联网行业从业经验，9年产品设计经验"],
        //   tag2: ["13年互联网行业从业经验<br/>9年产品设计经验"],
        //   info: [
        //     "从事过开发、运营和产品工作，对互联网产品全周期管理有丰富的实战经验，涉足社交、TMT、在线教育、电商、B端等行业，曾主导完成多家传统企业互联网转型，0-1项目经验丰富。对于产品设计、产品创新、产品开发、产品规划等方面有丰富经验。",
        //   ],
        // },
        // {
        //   name: "周老师",
        //   tag: ["7年以上产品经理实战以及咨询解决方案经验"],
        //   tag2: ["7年以上产品经理实战<br/>以及咨询解决方案经验"],
        //   info: [
        //     "曾任职复星集团产品经理，独立负责公司营销中台产品0~1的搭建，从0开始，两年内用户增长突破百万，年流水过亿。主要涉足营销、分销、数据产品等领域。善于产品解决方案、MVP模型、数字驱动迭代领域研究。",
        //   ],
        // },
      ],
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 14;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
    changeCur(index, num) {
      this.show = true;
      if (num == 1) {
        this.cur = index + 1;
      } else {
        this.cur = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box6 {
  padding: 80px 0 60px;

  width: 100%;
  background: url("../../../assets/coursePage/pm/box6/bgc.png") no-repeat;
  background-size: cover;

  .teacher-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .teacher-box {
    margin: 70px auto 0;
    width: 100%;
    overflow-x: auto;

    .box1,
    .box2 {
      display: flex;
      margin-left: 47px;
      width: 100%;
      .seat {
        width: 30px;
        flex-shrink: 0;
      }
    }
    .scorll-box {
      position: absolute;
      left: 50%;
      margin-top: 4px;
      transform: translate(-50%, 0px);
      width: 60px;
      height: 6px;
      background-color: #c9c7ff;
      border-radius: 3px;
      .scorll-block {
        position: absolute;
        left: var(--box-left);
        width: 20px;
        height: 6px;
        background-color: #5d5bf5;
        border-radius: 3px;
      }
    }
    .teacher {
      flex-shrink: 0;
      margin-bottom: 28px;
      padding: 0 0px 0 22px;
      margin-right: 28px;
      width: 658px;
      height: 304px;
      background-color: #e0f5ff;
      border-radius: 10px;
      /* border: solid 2px #ffffff; */
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .tName {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        margin-top: 272px;
      }
      .tagList {
        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
          margin-top: 4px;
        }
      }
    }
  }

  .pop {
    padding: 48px 48px 58px 48px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
      margin-top: 16px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;
      margin-top: 16px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }
}
</style>
